import React from 'react';
import {
  Box, SimpleGrid, Text, Heading, HStack,
} from '@chakra-ui/react';
import { IcAcCoverage as IcAcCoverageData } from '../types';
import { useLanguage } from '../hooks/useLanguage';

interface Props {
  data: IcAcCoverageData;
}

const CoverageCard: React.FC<{
  label: string;
  value: number;
  total?: number;
  percent?: number;
  color: string;
}> = ({ label, value, total, percent, color }) => (
  <Box bg="white" p={4} borderRadius="lg" boxShadow="sm" borderLeft="4px solid" borderColor={color}>
    <Text fontSize="xs" fontWeight="bold" color="gray.500">{label}</Text>
    <HStack spacing={1} align="baseline">
      <Text fontSize="3xl" fontWeight="black" color="#0F2C59">{value}</Text>
      {total != null && <Text fontSize="sm" color="gray.500">/ {total}</Text>}
    </HStack>
    {percent != null && <Text fontSize="xs" color="gray.500" mt={1}>{percent}%</Text>}
  </Box>
);

const IcAcCoverage: React.FC<Props> = ({ data }) => {
  const { t } = useLanguage();
  const s = data.summary;

  return (
    <Box>
      <Heading size="md" color="#0F2C59" mb={4}>
        {t('icac.title')}
      </Heading>

      <SimpleGrid columns={{ base: 2, md: 3, lg: 5 }} spacing={4}>
        <CoverageCard label={t('icac.totalMasters')} value={s.total_masters} color="gray.400" />
        <CoverageCard label={t('icac.mastersWithIc')} value={s.masters_with_ic} total={s.total_masters} percent={s.ic_coverage_percent} color="#2ECC71" />
        <CoverageCard label={t('icac.mastersWithAc')} value={s.masters_with_ac} total={s.total_masters} percent={s.ac_coverage_percent} color="#E59834" />
        <CoverageCard label={t('icac.icWithEvidence')} value={s.ic_with_evidence} total={s.total_ic} percent={s.ic_evidence_percent} color="#3182CE" />
        <CoverageCard label={t('icac.acWithEvidence')} value={s.ac_with_evidence} total={s.total_ac} percent={s.ac_evidence_percent} color="#805AD5" />
      </SimpleGrid>
    </Box>
  );
};

export default IcAcCoverage;
